import React, { createContext, useContext } from 'react';
import { useStatesHelper } from 'features/tasks-forms';


const StateReactContext = createContext<{
  id: string,
  label: string,
} | undefined>(undefined);

export function useStateContext() {
  const context = useContext(StateReactContext);
  if (context === undefined) {
    throw new Error('useStateContext must be used within a StateContextProvider');
  }
  return context;
}

export function StateContext(props: {
  state?: string,
  children?: React.ReactNode
}) {
  const statesHelper = useStatesHelper();

  return (
    <StateReactContext.Provider value={props.state
      ? {
        id: props.state,
        label: statesHelper.getLabelByValue(props.state),
      }
      : {
        id: 'nostate',
        label: 'No state',
      }
    }>
      {props.children}
    </StateReactContext.Provider>
  )
}
